import React from 'react'
import CenterMessage from '../CenterMessage'

const InspectorRestricted = () => (
  <CenterMessage
    title="Inspector not available"
    description="You need to be an Editor to measure and view the document’s design attributes."
  />
)

export default InspectorRestricted
